export enum ColumnStatus {
    Available = 'available',
    Processing = 'processing',
    Deleting = 'deleting',
    Stuck = 'stuck',
    Failed = 'failed',
}
